module.exports = __webpack_public_path__ + "media/flags/cn-6e0aea53.png";